import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";

export interface DashboardSummaryData {
  daily: Array<{
    count: number;
    date: string;
  }>;
  weekly: Array<{
    week: string;
    date: string;
    count: number;
  }>;
  monthly: Array<{
    count: number;
    date: string;
  }>;
  yearly: Array<{
    count: number;
    date: number;
  }>;
  iccidStatus: {
    active: number;
    inactive: number;
  };
  activationRequestCount: number
}

export interface DashboardSummaryResponse {
  data: DashboardSummaryData;
}

export const getDashboardSummary = (): Promise<DashboardSummaryResponse> => {
  return axios.get(API_ROUTES.DASHBOARD.SUMMARY);
}; 